module.exports = __webpack_public_path__ + "static/media/phone.3138ea06.svg";